import { Component, effect } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '.././app/components/login/login.service';
import { AppSettings } from './shared/app-settings';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { ClarityService } from './services/clarity.service';
import { AppUpdateService } from './services/app-update.service';
import { QuickCaptureService } from './components/quick-capture/quick-capture.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  user = null;
  loggedIn = false;
  constructor(
    public translate: TranslateService, 
    public loginService: LoginService, 
    private router: Router,
    private clarityService: ClarityService,
    private appUpdateService: AppUpdateService,
    private quickCaptureService: QuickCaptureService
  ) {
    this.loadData();
    
    // Initialize app update service to check for new versions
    this.appUpdateService.listenForUnrecoverableState();
    router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          if (event.navigationTrigger == 'popstate') {
            window.location.reload();
          }
        }
        if (event instanceof NavigationEnd) {
          this.setRootBgForRoute(event.urlAfterRedirects || event.url);
        }
      });

    // Set initial state on first load
    this.setRootBgForRoute(this.router.url);
  }

  loadData() {
    this.translate.addLangs(['en', 'no']);
    this.translate.setDefaultLang('no');
    effect(() => {
      this.loggedIn = this.loginService.isLoggedIn();
      if (this.loggedIn) {
        const userRaw = localStorage.getItem(AppSettings.StorageKeys.User);
        try {
          this.user = userRaw ? JSON.parse(userRaw) : null;
        } catch {
          this.user = null;
        }
        if (!this.user) {
          return;
        }

        const title = document.querySelector('head title');
        const userFullname = typeof this.user?.userFullname === 'string' ? this.user.userFullname : '';
        const accountName = typeof this.user?.accountName === 'string' ? this.user.accountName : '';
        if (title) {
          title.innerHTML = `Konti ePortal - ${userFullname} - ${accountName}`;
        }

        const rawLanguage = this.user?.userLanguage;
        const userLanguage = typeof rawLanguage === 'string' ? rawLanguage.trim().toLowerCase() : '';
        this.translate.setDefaultLang(userLanguage !== '' ? userLanguage : 'no');
        
        // Initialize Clarity when user is logged in
        this.initializeClarity();
      }
    });
  }

  private initializeClarity() {
    // Initialize Clarity after user is authenticated
    this.clarityService.initialize('tidb6ojyu2');
    
    // Identify the user to Clarity if available
    if (this.user) {
      this.clarityService.identify(
        this.user.userId || this.user.userEmployeeNo, 
        undefined, // sessionId
        undefined, // pageId
        this.user.userFullname
      );
      
      // Set useful tags for Clarity
      this.clarityService.setTag('domain', window.location.hostname);
      this.clarityService.setTag('userRole', this.user.userLevel || 'unknown');
      this.clarityService.setTag('language', this.user.userLanguage || 'no');
    }
  }

  private setRootBgForRoute(url: string) {
    const root = document.querySelector('app-root') as HTMLElement | null;
    if (!root) return;
    const isLogin = !!url && url.startsWith('/login');
    root.classList.toggle('login-bg', isLogin);
  }

}
